export enum TrackEvents {
  WEBSITE = 'webshop_view',
  BUY_CREDIT_VIEW = 'webshop_buy_credits_page_view',
  PHONE_NUMBER_ENTRY_VIEW = 'webshop_phone_number_entry_view',
  PACKAGE_SELECTION = 'webshop_package_selection',
  PAYMENT_FLOW_STARTED = 'webshop_payment_flow_started',
  REDEEM_VOUCHER_VIEW = 'webshop_redeem_voucher_view',
  REDEEM_VOUCHER_SUCCESS = 'webshop_redeem_voucher_success',
  REDEEM_VOUCHER_FAILURE = 'webshop_redeem_voucher_failure',
  PROMO_CODE_VIEW = 'webshop_promo_code_view',
  PROMO_CODE_SUCCESS = 'webshop_promo_code_success',
  PROMO_CODE_FAILURE = 'webshop_promo_code_failure',
}
